import { useState, useContext, PropsWithChildren } from 'react';
import classnames from 'classnames';
import { Button, Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';

import Sidenav from './Sidenav';
import Navbar from './Navbar';
import AuthenticatedDropdownMenu from './AuthenticatedDropdownMenu';
import { FaBars } from 'react-icons/fa';
import { GlobalContext } from '../../context/GlobalContext';
import FooterCopyright from './FooterCopyright';
import StaffLayout from './StaffLayout';
import PromoPrompt from '../promo/PromoPrompt';
import { isCapacitorBuild } from '../../utils/platform';

const ICON_BARS = <FaBars className="dp-font-lg" />;

const AuthenticatedLayout = (
  props: PropsWithChildren<{ pathname: string }>
) => {
  const {
    userAuth: { isEmployer, isStaff },
  } = useContext(GlobalContext);
  const [offcanvasIsOpen, setOffcanvasIsOpen] = useState(false);
  function toggleOffcanvas() {
    setOffcanvasIsOpen((prev) => !prev);
  }

  if (isStaff) {
    return (
      <StaffLayout pathname={props.pathname}>{props.children}</StaffLayout>
    );
  } else if (isEmployer) {
    return (
      <>
        <PromoPrompt mode="banner" />
        <div
          className={classnames(
            'w-100 border-bottom bg-white flex-shrink-0 border-secondary'
          )}
        >
          <Navbar>
            <div className="d-flex flex-nowrap align-items-center">
              <AuthenticatedDropdownMenu />
              {/* MOBILE DROPDOWN ACTIONS*/}
              <Button
                color="link"
                onClick={toggleOffcanvas}
                className="d-lg-none text-black pe-0"
                aria-label="Main Menu"
              >
                {ICON_BARS}
              </Button>
              <Offcanvas
                id="sidenav-offcanvas"
                direction="end"
                isOpen={offcanvasIsOpen}
                toggle={toggleOffcanvas}
                className={isCapacitorBuild ? 'offcanvas-inset' : ''}
              >
                <OffcanvasHeader toggle={toggleOffcanvas}></OffcanvasHeader>
                <OffcanvasBody className="bg-solids-off-white-50 px-0 pt-0">
                  <Sidenav toggle={toggleOffcanvas} />
                </OffcanvasBody>
              </Offcanvas>
            </div>
          </Navbar>
        </div>
        <div className="bg-solids-off-white-50 authenticated d-flex flex-grow-1 overflow-hidden">
          <div className="d-none d-lg-flex d-print-none bg-white border-end justify-content-center overflow-y-scroll dp-w-fit">
            <Sidenav />
          </div>
          <div
            className="col overflow-y-scroll overflow-x-hidden"
            id="main-content"
          >
            <main role="main" className="dp-min-h-full">
              {props.children}
            </main>
            <footer role="contentinfo">
              <FooterCopyright />
            </footer>
          </div>
        </div>
      </>
    );
  } else {
    return <div>{props.children}</div>;
  }
};

export default AuthenticatedLayout;
